import React from 'react';
import { IReCaptchaComponentProps } from './recaptcha.props';
import { IReCaptchaComponentState } from './recaptcha.state';
import { Sede } from '../../classes/shared';

export class ReCaptchaComponent extends React.Component<IReCaptchaComponentProps, IReCaptchaComponentState> {

  constructor(props: any) {
    super(props);
    this.props.onInitialize(this);
  }

  render(): JSX.Element {
    return (
      <div id='g-ioip'></div>
    );
  }

  public initialize(): void {
    const grecaptcha = window['grecaptcha' as any] as any;
    if (grecaptcha === undefined) {
      alert('Recaptcha no initializado');
      return;
    }
    var stSiteKey = Sede.Shared.Context.ReCaptchaSiteKey !== '' ? Sede.Shared.Context.ReCaptchaSiteKey : '6LdzAsUUAAAAADxhEwEl-mp5j_MT6V1Pmx8Vs1U3';
    grecaptcha.render('g-ioip', {
      'sitekey': stSiteKey
    });
  }

  public isValid(): { isCaptchaValid: boolean; recaptchaToken: string } {
    const grecaptcha = window['grecaptcha' as any] as any;
    let isCaptchaValid: boolean = false;
    let recaptchaToken: string = ''
    if (grecaptcha === undefined) {
      alert('Recaptcha no initializado');
    }
    else {
      const gReponse = grecaptcha.getResponse();
      isCaptchaValid = (gReponse !== '');
      recaptchaToken = gReponse;
    }
    return { isCaptchaValid, recaptchaToken };
  }

  public isValid2(callback): boolean {
    const grecaptcha = window['grecaptcha' as any] as any;
    if (grecaptcha === undefined) {
      alert('Recaptcha no initializado');
      return false;
    }
    grecaptcha.ready(function () {
      grecaptcha.execute('6LdzAsUUAAAAADxhEwEl-mp5j_MT6V1Pmx8Vs1U3', { action: 'submit' }).then(function (token) {
        callback();
      });
    });

  }


}